export default __webpack_public_path__ + "static/media/dashboard.b4087639.svg";